module.exports = __webpack_public_path__ + "img/tab-3.cb4e017f.png";